/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon16Regular = forwardRef('MediaUiAEjectIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.271 8.74c-.63.822-.044 2.01.992 2.01h9.474c1.036 0 1.622-1.188.992-2.01L9.07 2.664a1.35 1.35 0 0 0-2.142 0L2.27 8.739ZM8 3.732l4.23 5.517H3.77L8 3.733Z" }),
        React.createElement("path", { d: "M2.75 12.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z" })));
});
